import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../utils/Api";
import StaticFunctions from "../utils/StaticFunctions";

import './LoginPage.css';

class Register extends Component {

    static propTypes = {
        languages: PropTypes.array.isRequired,
        translate: PropTypes.func.isRequired,
        zskLinks: PropTypes.object.isRequired,
        i18n: PropTypes.object.isRequired,
        setUrlStateParams: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.translate;
        this.selectedLanguage = props.i18n.language;
        this.requiredFields = ['user_langselector', 'user_title', 'user_firstName', 'user_lastName', 'user_emailOfMainUser', 'user_password', 'user_confirmPassword', 'company_companyOrName', 'company_street', 'company_postAddress', 'serviceContract_iAcceptTheContract'];

        this.state = {
            inputParams: {
                user_langselector: props.i18n.language,
                company_plantInformationManagementModule: true,
                user_title: this.translate('mr')
            },
            errorFields: [],
            foldable: {}
        };

        this.handleRequest = this.handleRequest.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.handleOption = this.handleOption.bind(this);
        this.getInputClasses = this.getInputClasses.bind(this);

    }

    handleRequest() {

        const params = {...this.state.inputParams};

        if (this.validateParams(params)) {
            const callback = function (res) {
                if (res) {
                    if (res.success) {
                        this.props.setUrlStateParams({
                            show: 'registersuccsess',
                            registerMail: this.state.inputParams.user_emailOfMainUser
                        });
                    } else {
                        alert(this.translate(res.msgKey));
                    }
                } else {
                    alert(this.translate('errorOccured'));
                }
            }.bind(this);

            this.api.request('Register', params, callback, null);
        } else {
            const isEmail = (params.user_emailOfMainUser) ? StaticFunctions.validateEmail(params.user_emailOfMainUser) : false;
            //const isVatNumber = StaticFunctions.validateVatNumber(params.company_vatNumber, false);
            const passwordStatus = StaticFunctions.validatePassword(params.user_password, params.user_confirmPassword);
            const errorFields = StaticFunctions.checkRequiredFields(params, this.requiredFields);

            if (isEmail === false) errorFields.push('user_emailOfMainUser');
            //if (isVatNumber === false) errorFields.push('company_vatNumber');	//24-A0210F: O. Schipper: Bitte die Validierung Deaktivieren.
            if (passwordStatus === 'errorNewPasswordNotConfirmed' || passwordStatus === 'passwordsDontMatch') errorFields.push('user_confirmPassword');
            if (passwordStatus === 'errorNewPasswordUnset' || passwordStatus === 'errorNewPasswordToShort' || passwordStatus === 'errorNewPasswordUnsure') {
                errorFields.push('user_password');
                errorFields.push('user_confirmPassword');
            }

            this.setState({
                errorFields
            });

            if (passwordStatus !== true) {
                alert(this.translate(passwordStatus));
            } else {
                alert(this.translate('pleaseCompleteRequiredFields'));
            }
        }

    }

    handleCancel() {

        this.props.setUrlStateParams();

    }

    handleInput(fieldName, value) {

        if (!fieldName) return null;

        const inputParams = {...this.state.inputParams};

        inputParams[fieldName] = value;

        this.setState({inputParams});

    }

    handleOption(event, fieldName) {

        if (!event || !fieldName) return null;

        const inputParams = {...this.state.inputParams};

        inputParams[fieldName] = event.target.value;

        this.setState({inputParams});

    }

    changeLanguage(event) {

        if (event) {
            const selectedLanguage = event.target.value;

            this.selectedLanguage = selectedLanguage;
            this.props.i18n.changeLanguage(selectedLanguage);
            this.handleInput('user_langselector', selectedLanguage);
        }

    }

    validateParams(params) {

        const validatedEmail = (params.user_emailOfMainUser) ? StaticFunctions.validateEmail(params.user_emailOfMainUser) : false;
        const validatePassword = StaticFunctions.validatePassword(params.user_password, params.user_confirmPassword);
        //const validatedTaxNumber = (params.company_vatNumber) ? StaticFunctions.validateVatNumber(params.company_vatNumber) : false;
        const validatedTaxNumber = StaticFunctions.validateVatNumber(params.company_vatNumber, false);
        const validateRequiredFields = StaticFunctions.validateRequiredFields(params, this.requiredFields);

        return (validatedEmail && validatedTaxNumber && validatePassword === true && validateRequiredFields);

    }

    foldHandle(htmlId, value = null) {

        if (htmlId) {
            const foldable = this.state.foldable;

            if (foldable[htmlId]) {
                if (value === null) {
                    foldable[htmlId] = !foldable[htmlId];
                } else {
                    foldable[htmlId] = value;
                }
            } else {
                foldable[htmlId] = true;
            }

            this.setState({foldable});
        }

    }

    getLanguageOptions() {

        const languages = this.props.languages;

        return languages.map(
            (language, index) => {
                return (
                    <option key={'option-' + index} value={language.value}>{language.label}</option>
                );
            }
        );

    }

    getTitleOptions() {

        const titles = [];

        if (this.state.inputParams.user_langselector === 'de') {
            titles.push(this.translate('mr'), this.translate('mrs'));
        } else {
            titles.push(this.translate('mr'), this.translate('ms'), this.translate('mrs'));
        }

        return titles.map(
            (title, index) => {
                return (
                    <option key={'option-' + index} value={title}>{title}</option>
                );
            }
        );

    }

    getInputClasses(fieldName) {

        return ['input__field', ((this.state.errorFields.includes(fieldName)) ? 'error' : '')].join(' ').trim();


    }

    render() {

        const languageOptions = this.getLanguageOptions();
        const titleOptions = this.getTitleOptions();

        //const securityColor = (this.state.securityLevel !== null) ? {backgroundColor: StaticFunctions.getSecurityColorFromLevel(this.state.securityLevel)} : null;

        const contactFinance = 'firstTr40 foldable' + ((this.state.foldable && this.state.foldable.contactFinance) ? ' open' : '');
        const techContact = 'firstTr40 foldable' + ((this.state.foldable && this.state.foldable.techContact) ? ' open' : '');
        const addressDatacollector = 'firstTr40 foldable' + ((this.state.foldable && this.state.foldable.addressDatacollector) ? ' open' : '');

        const zskUrl = this.props.zskLinks.homePage;
        const zskHomePage = zskUrl + ((this.selectedLanguage === 'de') ? '/de' : '/en') ;
        const zskImprintLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.imprint;
        const zskPolicyLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.policy;
        const zskConditionLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.condition;
        const zskContactLink = zskUrl + '/' + ((this.selectedLanguage === 'de') ? 'de' : 'en') + this.props.zskLinks.contact;

        //const checkedPlantInformationManagementModule = (this.state.inputParams && this.state.inputParams.company_plantInformationManagementModule) ? this.state.inputParams.company_plantInformationManagementModule : false;

        return (
            <div>
                <div>
                    {/*<!-- BG Teaser + Verläufe -->*/}
                    <div id="MyTeaser" style={{display: 'block'}}>&nbsp;</div>
                    <div id="gradients" style={{display: 'block'}}>&nbsp;</div>
                    {/*<!-- / BG Teaser + Verläufe -->*/}

                    <header style={{display: 'block'}}>My.ZSK</header>

                    <div className="formdata">
                        <div>
                            <h1>{this.translate('registerToMyzsk')}</h1>

                            <table className="firstTr40" style={{borderBottom: '2px solid #fff', marginBottom: 10, width: '100%'}}>
                                <tbody>
                                    <tr>
                                        <td className="text-left">{this.translate('language')}</td>

                                        <td className="text-left selbox">
                                            <div className="lang-select">
                                                <div id="ddArr" className="arrow">&nbsp;</div>

                                                <select id="user_langselector" value={this.selectedLanguage} onChange={(event) => this.changeLanguage(event)}>
                                                    {languageOptions}
                                                </select>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className="firstTr40" style={{borderBottom: '2px solid #fff', marginBottom: 10, width: '100%'}}>
                                <tbody>
                                    <tr><td className="text-left" colSpan="2"><h4>{this.translate('user')}</h4></td></tr>

                                    <tr>
                                        <td className="text-left">{this.translate('title') + '*'}</td>

                                        <td>
                                            <div className="lang-select">
                                                <div id="ddArr" className="arrow">&nbsp;</div>

                                                <select id="user_title" value={this.state.inputParams.user_title} onChange={(event) => this.handleOption(event, 'user_title')}>
                                                    {titleOptions}
                                                </select>
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('firstName') + '*'}</td>

                                        <td className="text-left">
                                            <input
                                                id="user_firstName"
                                                name="firstName"
                                                className={this.getInputClasses('user_firstName')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('user_firstName', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('lastName') + '*'}</td>

                                        <td className="text-left">
                                            <input
                                                id="user_lastName"
                                                name="lastName"
                                                className={this.getInputClasses('user_lastName')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('user_lastName', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('phone')}</td>

                                        <td className="text-left">
                                            <input
                                                id="user_phone"
                                                name="phone"
                                                className={this.getInputClasses('user_phone')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('user_phone', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('emailOfMainUser') + '*'}</td>

                                        <td className="text-left">
                                            <input
                                                id="user_emailOfMainUser"
                                                name="emailOfMainUser"
                                                className={this.getInputClasses('user_emailOfMainUser')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('user_emailOfMainUser', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('password') + '*'}</td>

                                        <td className="text-left">
                                            <input
                                                id="user_password"
                                                name="password"
                                                className={this.getInputClasses('user_password')}
                                                type="password"
                                                onBlur={(event) => this.handleInput('user_password', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('confirmPassword') + '*'}</td>

                                        <td className="text-left">
                                            <input
                                                id="user_confirmPassword"
                                                name="confirmPassword"
                                                className={this.getInputClasses('user_confirmPassword')}
                                                type="password"
                                                onBlur={(event) => this.handleInput('user_confirmPassword', event.target.value)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className="firstTr40" style={{borderBottom: '2px solid #fff', marginBottom: 10, width: '100%'}}>
                                <tbody>
                                    <tr><td className="text-left" colSpan="2"><h4>{this.translate('billingAddress')}</h4></td></tr>

                                    <tr>
                                        <td className="text-left">{this.translate('companyOrName') + '*'}</td>

                                        <td className="text-left">
                                            <input
                                                id="company_companyOrName"
                                                name="companyOrName"
                                                className={this.getInputClasses('company_companyOrName')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('company_companyOrName', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('street') + '*'}</td>

                                        <td className="text-left">
                                            <input
                                                id="company_street"
                                                name="street"
                                                className={this.getInputClasses('company_street')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('company_street', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('postAddress') + '*'}</td>

                                        <td className="text-left">
                                            <input
                                                id="company_postAddress"
                                                name="postAddress"
                                                className={this.getInputClasses('company_postAddress')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('company_postAddress', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('taxNumber')}</td>

                                        <td className="text-left">
                                            <input
                                                id="company_vatNumber"
                                                name="vatNumber"
                                                className={this.getInputClasses('company_vatNumber')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('company_vatNumber', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('extra')}</td>

                                        <td className="text-left">
                                            <input
                                                id="company_extra"
                                                name="extra"
                                                className={this.getInputClasses('company_extra')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('company_extra', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('costCenter')}</td>

                                        <td className="text-left">
                                            <input
                                                id="company_costCenter"
                                                name="costCenter"
                                                className={this.getInputClasses('company_costCenter')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('company_costCenter', event.target.value)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <table id="contactFinance" className={contactFinance} style={{borderBottom: '2px solid #fff', marginBottom: 10, width: '100%'}}>
                                <tbody>
                                    <tr><td className="text-left" colSpan="2" onClick={() => this.foldHandle('contactFinance')}><h4>{this.translate('contactFinance') + ' ' + this.translate('onlyWhenDiffersFromMainuser')}</h4></td></tr>

                                    <tr>
                                        <td className="text-left">{this.translate('title')}</td>

                                        <td className="text-left">
                                            <input
                                                id="contactFinance_title"
                                                name="contactFinance_title"
                                                className={this.getInputClasses('contactFinance_title')}
                                                type="text"
                                                onFocus={() => this.foldHandle('contactFinance', true)}
                                                onBlur={(event) => this.handleInput('contactFinance_title', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('firstName')}</td>

                                        <td className="text-left">
                                            <input
                                                id="contactFinance_firstName"
                                                name="contactFinance_firstName"
                                                className={this.getInputClasses('contactFinance_firstName')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('contactFinance_firstName', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('lastName')}</td>

                                        <td className="text-left">
                                            <input
                                                id="contactFinance_lastName"
                                                name="contactFinance_lastName"
                                                className={this.getInputClasses('contactFinance_lastName')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('contactFinance_lastName', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('email')}</td>

                                        <td className="text-left">
                                            <input
                                                id="contactFinance_email"
                                                name="contactFinance_email"
                                                className={this.getInputClasses('contactFinance_email')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('contactFinance_email', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('phone')}</td>

                                        <td className="text-left">
                                            <input
                                                id="contactFinance_phone"
                                                name="contactFinance_phone"
                                                className={this.getInputClasses('contactFinance_phone')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('contactFinance_phone', event.target.value)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <table id="techContact" className={techContact} style={{borderBottom: '2px solid #fff', marginBottom: 10, width: '100%'}}>
                                <tbody>
                                    <tr><td className="text-left" colSpan="2" onClick={() => this.foldHandle('techContact')}><h4>{this.translate('techContact') + ' ' + this.translate('onlyWhenDiffersFromMainuser')}</h4></td></tr>

                                    <tr>
                                        <td className="text-left">{this.translate('title')}</td>

                                        <td className="text-left">
                                            <input
                                                id="techContact_title"
                                                name="techContact_title"
                                                className={this.getInputClasses('techContact_title')}
                                                type="text"
                                                onFocus={() => this.foldHandle('techContact', true)}
                                                onBlur={(event) => this.handleInput('techContact_title', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('firstName')}</td>

                                        <td className="text-left">
                                            <input
                                                id="techContact_firstName"
                                                name="techContact_firstName"
                                                className={this.getInputClasses('techContact_firstName')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('techContact_firstName', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('lastName')}</td>

                                        <td className="text-left">
                                            <input
                                                id="techContact_lastName"
                                                name="techContact_lastName"
                                                className={this.getInputClasses('techContact_lastName')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('techContact_lastName', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('email')}</td>

                                        <td className="text-left">
                                            <input
                                                id="techContact_email"
                                                name="techContact_email"
                                                className={this.getInputClasses('techContact_email')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('techContact_email', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('phone')}</td>

                                        <td className="text-left">
                                            <input
                                                id="techContact_phone"
                                                name="techContact_phone"
                                                className={this.getInputClasses('techContact_phone')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('techContact_phone', event.target.value)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <table id="addressDatacollector" className={addressDatacollector} style={{borderBottom: '2px solid #fff', marginBottom: 10, width: '100%'}}>
                                <tbody>
                                    <tr><td className="text-left" colSpan="2" onClick={() => this.foldHandle('addressDatacollector')}><h4>{this.translate('addressDatacollector') + ' ' + this.translate('onlyWhenDiffersFromMainuser')}</h4></td></tr>

                                    <tr>
                                        <td className="text-left">{this.translate('company')}</td>

                                        <td className="text-left">
                                            <input
                                                id="addressDatacollector_company"
                                                name="addressDatacollector_company"
                                                className={this.getInputClasses('addressDatacollector_company')}
                                                type="text"
                                                onFocus={() => this.foldHandle('addressDatacollector', true)}
                                                onBlur={(event) => this.handleInput('addressDatacollector_company', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('extra')}</td>

                                        <td className="text-left">
                                            <input
                                                id="addressDatacollector_extra"
                                                name="addressDatacollector_extra"
                                                className={this.getInputClasses('addressDatacollector_extra')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('addressDatacollector_extra', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('street')}</td>

                                        <td className="text-left">
                                            <input
                                                id="addressDatacollector_street"
                                                name="addressDatacollector_street"
                                                className={this.getInputClasses('addressDatacollector_street')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('addressDatacollector_street', event.target.value)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('postAddress')}</td>

                                        <td className="text-left">
                                            <input
                                                id="addressDatacollector_postAddress"
                                                name="addressDatacollector_postAddress"
                                                className={this.getInputClasses('addressDatacollector_postAddress')}
                                                type="text"
                                                onBlur={(event) => this.handleInput('addressDatacollector_postAddress', event.target.value)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className="lastTr3" style={{borderBottom: '2px solid #fff', marginBottom: 10, width: '100%'}}>
                                <tbody>
                                    <tr><td className="text-left" colSpan="2"><h4>{this.translate('technicalInformation')}</h4></td></tr>

                                    <tr>
                                        <td className="text-left">{this.translate('netAccessIsAvailable')}</td>

                                        <td className="text-left">
                                            <input
                                                id="technicalInformation_netAccessIsAvailable"
                                                name="technicalInformation_netAccessIsAvailable"
                                                type="checkbox"
                                                onChange={(event) => this.handleInput('technicalInformation_netAccessIsAvailable', event.target.checked)}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('zskMachinesAreAvailable')}</td>

                                        <td className="text-left">
                                            <input
                                                id="technicalInformation_zskMachinesAreAvailable"
                                                name="technicalInformation_zskMachinesAreAvailable"
                                                type="checkbox"
                                                onChange={(event) => this.handleInput('technicalInformation_zskMachinesAreAvailable', event.target.checked)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className="firstTr40" style={{borderBottom: '2px solid #fff', marginBottom: 10, width: '100%'}}>
                                <tbody>
                                    <tr><td className="text-left" colSpan="2"><h4>{this.translate('other')}</h4></td></tr>

                                    <tr>
                                        <td className="text-left">{this.translate('additionalInfo')}</td>

                                        <td className="text-left">
                                            <textarea
                                                id="other_additionalInfo"
                                                name="additionalInfo"
                                                className={this.getInputClasses('other_additionalInfo')}
                                                onBlur={(event) => this.handleInput('other_additionalInfo', event.target.value)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className="lastTr3" style={{borderBottom: '2px solid #fff', marginBottom: 10, width: '100%'}}>
                                <tbody>
                                    <tr><td className="text-left" colSpan="2"><h4>{this.translate('serviceContract')}</h4></td></tr>

                                    <tr>
                                        <td className="text-left">{this.translate('linkToContract')}</td>

                                        <td className="text-left">
                                            <a id="linkServiceContract" href="https://my.zsk.de/doc/de/service_contract_de.pdf" target="_blank">{this.translate('serviceContract')}</a>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left">{this.translate('iAcceptTheContract') + '*'}</td>

                                        <td className="text-left">
                                            <input
                                                id="serviceContract_iAcceptTheContract"
                                                name="serviceContract_iAcceptTheContract"
                                                type="checkbox"
                                                onChange={(event) => this.handleInput('serviceContract_iAcceptTheContract', event.target.checked)}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="noteBox" style={{margin: '0 0 20px'}}>* {this.translate('requiredFields')}</div>

                        <div>
                            <div className="clearfix">
                                <div className="submitmsgcontainer">
                                    <div className="clearfix">
                                        <div className="buttonFrame flr">
                                            <input type="submit" onClick={() => this.handleRequest()} value={this.translate('submit')}/>
                                        </div>

                                        <div className="buttonFrame fll">
                                            <input type="button" onClick={() => this.handleCancel()} value={this.translate('cancel')}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <footer style={{display: 'block'}}>
                        <div className="rt">
                            <p>
                                <a href={zskHomePage} target="_blank" rel="noopener noreferrer">www.zsk.de</a>
                                |
                                <a href={zskConditionLink} target="_blank" rel="noopener noreferrer">{this.translate('termsAndConditions')}</a>
                                |
                                <a href={zskPolicyLink} target="_blank" rel="noopener noreferrer">{this.translate('privacyPolicy')}</a>
                                |
                                <a href={zskImprintLink} target="_blank" rel="noopener noreferrer">{this.translate('imprint')}</a>
                            </p>
                        </div>

                        <div className="lb">
                            <p>
                                <a href={zskContactLink} target="_blank" rel="noopener noreferrer" className="contactIcon">{this.translate('contact')}</a>
                            </p>
                        </div>

                        <div className="mig">Made in Germany</div>
                    </footer>
                </div>

                <style dangerouslySetInnerHTML={{__html: `#atlwdg-trigger {display : none;}`}}/>
            </div>
        );

    }

}

export default Register;